export default function _backToTop() {
    /**
     * Component item selector
     * @const {string}
     */
    const BUTTON_SELECTOR = '.js-back-to-top';

    class BackToTop {
        constructor(component) {
            this.onBackToTopClick = this.onBackToTopClick.bind(this);
            component.addEventListener('click', this.onBackToTopClick);
        }

        onBackToTopClick(evt) {
            evt.preventDefault();

            // This works well in Firefox and Chrome.
            // For Safari and Edge, it just snaps to the top of the page.
            (document.body || document.documentElement).scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    }

    const components = document.querySelectorAll(BUTTON_SELECTOR);
    components.forEach((component) => {
        const DOMItem = component;

        // Attach the instance to the DOM once
        if (!DOMItem.component) {
            DOMItem.component = new BackToTop(component);
        }
    });
}

_backToTop();
